import React, { Fragment } from 'react'
import NoImg from '../images/no-img.jpg'
import PropTypes from 'prop-types'

import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import Skeleton from '@material-ui/lab/Skeleton';

import withStyles from '@material-ui/core/styles/withStyles'    

const styles = (theme) => ({
        ...theme.spreadThis,
        card: {
            display: 'flex',
            marginBottom: 20
          },
          cardContent: {
            height: 151,
            width: '100%',
            flexDirection: 'column',
            padding: 25
          },
          cover: {
            minWidth: 128,
            objectFit: 'cover'
          }
})

const OpinionSkeleton = (props) => {
    const { classes } = props;
    const  content = Array.from({length: 3}).map((item, index) => (
        <Card className={classes.card} key={index}>
            <CardMedia className={classes.cover} image={NoImg} />
            <CardContent className={classes.cardContent}>
                <Skeleton animation="wave" height={30} width="20%" style={{ marginBottom: 4 }} />
                <Skeleton animation="wave" height={15} width="13%" style={{ marginBottom: 4 }} />
                <Skeleton animation="wave" height={20} width="90%" style={{ marginBottom: 4 }} />
                <Skeleton animation="wave" height={20} width="90%" style={{ marginBottom: 4 }} />
                <Skeleton animation="wave" height={20} width="45%" />
            </CardContent>
        </Card>

    ))

    return <Fragment>{content}</Fragment>
}

OpinionSkeleton.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(styles)(OpinionSkeleton)